import { render, staticRenderFns } from "./CoRIPanel.vue?vue&type=template&id=332dc608&"
import script from "./CoRIPanel.vue?vue&type=script&lang=js&"
export * from "./CoRIPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports